module.exports = __webpack_public_path__ + "img/sjltjb.64925d06.png";